require('./bootstrap');

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

import "./signature_pad";
import "./burger_menu";
import "./notifications"

// import "./adyen";

import "./paypal";

// Pobieranie w nowej karcie - dla Mozilli...
document.querySelectorAll('a[download]').forEach(function (element) {
    element.addEventListener('click', function (event) {
        event.preventDefault();

        const redirect = window.open(event.target.getAttribute('href'), '_black');
        redirect.location;
    });
})

// -- kod by ujednolicić z kontenerem na stronie Wordpresowskej
// const calculator = document.querySelector('.costCalculator')
// if (calculator != undefined){
//     document.querySelector('#guest').style.maxWidth = 'inherit'
// }
